import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { addStudent } from "../../store/slices/student";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import {
  FiHome,
  FiChevronRight,
} from "react-icons/fi";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { uploadadminImage } from "../../utils/helpers/fileupload";

import { fetchStandardSection } from "../../store/slices/getstandardsection";

import {
  nameregex,
  emailregex,
  mobileregex,
  aadharregex,
  rollNoRegex,
  religionnameregex,
  nationalitynameregex,
  ocupationregex,
  educationRegex,
  isValidStudentDateOfBirth,
} from "../../utils/Regex";

/* ---------- Required Messages ---------- */
const requiredMessages = {
  name: "Please enter student name",
  gender: "Please select gender",
  rollNo: "Please enter roll number",
  dob: "Please select date of birth",
  doa: "Please select date of admission",
  aadhaarNo: "Please enter Aadhaar number",
  religion: "Please enter  religion",
  nationality: "Please enter nationality",
  presentAddress: "Please enter present address",
  fatherName: "Please enter father name",
  fatherMobileNo: "Please enter father mobile number",
  motherName: "Please enter mother name",
  motherMobileNo: "Please enter mother mobile number",
};
const getAcademicSession = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); // Jan = 0, March = 2, April = 3

  // January, February, March
  if (currentMonth <= 2) {
    return `${currentYear - 1}-${String(currentYear).slice(-2)}`;
  }

  // April to December
  return `${currentYear}-${String(currentYear + 1).slice(-2)}`;
};

export default function AddStudent() {

  // access token
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user?.data?.accessToken;


  const [formData, setFormData] = useState({
    name: "",
    sectionId: "",
    standardId: "",
    gender: "",
    rollNo: "",
    dob: "",
    doa: "",
    session: getAcademicSession(),
    aadhaarNo: "",
    religion: "",
    nationality: "",
    presentAddress: "",
    permanentAddress: "",
    fatherName: "",
    fatherMobileNo: "",
    fatherEmail: "",
    fatherOccupation: "",
    fatheraadhaar: "",
    fatherQualification: "",
    motherName: "",
    motherMobileNo: "",
    motherEmail: "",
    motherOccupation: "",
    motheraadhaar: "",
    motherQualification: "",
    rte: "false",
    fatherImage: "",
    motherImage: "",
    image: "",
  });
  const [imagePreviews, setImagePreviews] = useState({
    image: "",
    fatherImage: "",
    motherImage: "",
  });
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { classsectionList = [] } = useSelector((state) => state.classsection);

  const standards = classsectionList.map((item) => item.standardId);

  const sections =
    classsectionList.find(
      (item) => item.standardId?._id === formData.standardId
    )?.sectionId || [];

  /* ---------- FETCH SECTIONS ---------- */
  useEffect(() => {
    dispatch(fetchStandardSection());
  }, [dispatch]);

  /* ---------- SECTION CHANGE ---------- */
  const handleSectionChange = (e) => {
    const sectionId = e.target.value;

    setFormData((prev) => ({
      ...prev,
      sectionId,
    }));

    validateField("sectionId", sectionId);
  };

  /* ---------- STANDARD CHANGE ---------- */
  const handleStandardChange = (e) => {
    const standardId = e.target.value;

    setFormData((prev) => ({
      ...prev,
      standardId,
      sectionId: "",
    }));

    setErrors((prev) => ({
      ...prev,
      standardId: standardId
        ? ""
        : "Please select standard",

      sectionId: "",
    }));

    if (!standardId) {
      dispatch(fetchStandardSection());
      return;
    }

    dispatch(fetchStandardSection(standardId));
  };
  /* ---------- Field Validation ---------- */
  const validateField = (name, value) => {
    let errorMessage = "";

    if (requiredMessages[name] && !String(value ?? "").trim()) {
      errorMessage = requiredMessages[name];
    } else if (name === "name" && value && !nameregex.test(value)) {
      errorMessage = "Name must contain only alphabets";
    } else if (name === "rollNo" && value && !rollNoRegex.test(value)) {
      errorMessage = "Invalid roll number";
    } else if (
      name === "dob" &&
      value &&
      !isValidStudentDateOfBirth(value)
    ) {
      errorMessage = "Student must be at least 2 years old";
    } else if (
      name === "aadhaarNo" &&
      value &&
      !aadharregex.test(value)
    ) {
      errorMessage = "Aadhaar must be 12 digits";
    } else if (
      name === "religion" &&
      value &&
      !religionnameregex.test(value)
    ) {
      errorMessage = "Please enter valid religion";
    } else if (
      name === "nationality" &&
      value &&
      !nationalitynameregex.test(value)
    ) {
      errorMessage = "Please enter valid nationality";
    } else if (
      ["fatherMobileNo", "motherMobileNo"].includes(name) &&
      value &&
      !mobileregex.test(value)
    ) {
      errorMessage = "Mobile number must be 10 digits";
    } else if (
      ["fatherEmail", "motherEmail"].includes(name) &&
      value &&
      !emailregex.test(value)
    ) {
      errorMessage = "Please enter valid email";
    } else if (
      ["fatherOccupation", "motherOccupation"].includes(name) &&
      value &&
      !ocupationregex.test(value)
    ) {
      errorMessage = "Please enter valid occupation";
    } else if (
      ["fatherQualification", "motherQualification"].includes(name) &&
      value &&
      !educationRegex.test(value)
    ) {
      errorMessage = "Please enter valid qualification";
    } else if (
      ["fatheraadhaar", "motheraadhaar"].includes(name) &&
      value &&
      !aadharregex.test(value)
    ) {
      errorMessage = "Aadhaar must be 12 digits";
    }

    setErrors((prev) => ({
      ...prev,
      [name]: errorMessage,
    }));

    return errorMessage;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    const numericFields = [
      "fatherMobileNo",
      "motherMobileNo",
      "aadhaarNo",
      "fatheraadhaar",
      "motheraadhaar",
    ];

    if (numericFields.includes(name)) {
      updatedValue = value.replace(/\D/g, "");
    }

    if (
      name === "fatherMobileNo" ||
      name === "motherMobileNo"
    ) {
      updatedValue = updatedValue.slice(0, 10);
    }

    if (
      name === "aadhaarNo" ||
      name === "fatheraadhaar" ||
      name === "motheraadhaar"
    ) {
      updatedValue = updatedValue.slice(0, 12);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    validateField(name, updatedValue);
  };


  // filehandle 
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    const file = files?.[0];

    if (!file) return;

    // Optional validation
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG, JPEG and PNG images are allowed");
      e.target.value = "";
      return;
    }

    // Optional 5 MB limit
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image size must be less than 5 MB");
      e.target.value = "";
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: file,
    }));

    setImagePreviews((prev) => {
      // Remove old blob URL
      if (prev[name]?.startsWith("blob:")) {
        URL.revokeObjectURL(prev[name]);
      }

      return {
        ...prev,
        [name]: URL.createObjectURL(file),
      };
    });
  };
  useEffect(() => {
    return () => {
      Object.values(imagePreviews).forEach((preview) => {
        if (preview?.startsWith("blob:")) {
          URL.revokeObjectURL(preview);
        }
      });
    };
  }, [imagePreviews]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    const fieldsToValidate = [
      "name",
      "standardId",
      "sectionId",
      "gender",
      "rollNo",
      "dob",
      "doa",
      "religion",
      "nationality",
      "presentAddress",
      "permanentAddress",

      "fatherName",
      "fatherMobileNo",
      "fatherOccupation",
      "fatherQualification",

      "motherName",
      "motherMobileNo",
      "motherOccupation",
      "motherQualification",
    ];

    const optionalFieldsToValidate = [
      "aadhaarNo",
      "fatherEmail",
      "fatheraadhaar",
      "motherEmail",
      "motheraadhaar",
    ];

    const newErrors = {};

    fieldsToValidate.forEach((field) => {
      const error = validateField(field, formData[field]);

      if (error) {
        newErrors[field] = error;
      }
    });

    optionalFieldsToValidate.forEach((field) => {
      if (formData[field]) {
        const error = validateField(field, formData[field]);

        if (error) {
          newErrors[field] = error;
        }
      }
    });

    setErrors((prev) => ({
      ...prev,
      ...newErrors,
    }));

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please correct the form errors");
      return;
    }

    try {
      let studentImageUrl = "";
      let fatherImageUrl = "";
      let motherImageUrl = "";

      if (formData.image instanceof File) {
        studentImageUrl = await uploadadminImage(
          formData.image,
          token
        );
      }

      if (formData.fatherImage instanceof File) {
        fatherImageUrl = await uploadadminImage(
          formData.fatherImage,
          token
        );
      }

      if (formData.motherImage instanceof File) {
        motherImageUrl = await uploadadminImage(
          formData.motherImage,
          token
        );
      }

      const payload = {
        name: formData.name.trim(),

        standardId: formData.standardId,
        sectionId: formData.sectionId,

        gender: formData.gender,
        rollNo: formData.rollNo.trim(),

        dob: formData.dob,
        doa: formData.doa,

        session: formData.session,

        aadhaarNo: formData.aadhaarNo,

        religion: formData.religion.trim(),
        nationality: formData.nationality.trim(),

        presentAddress: formData.presentAddress.trim(),
        permanentAddress: formData.permanentAddress.trim(),

        fatherName: formData.fatherName.trim(),
        fatherMobileNo: formData.fatherMobileNo,

        fatherEmail: formData.fatherEmail.trim(),

        fatherOccupation:
          formData.fatherOccupation.trim(),

        fatheraadhaar: formData.fatheraadhaar,

        fatherQualification:
          formData.fatherQualification.trim(),

        motherName: formData.motherName.trim(),
        motherMobileNo: formData.motherMobileNo,

        motherEmail: formData.motherEmail.trim(),

        motherOccupation:
          formData.motherOccupation.trim(),

        motheraadhaar: formData.motheraadhaar,

        motherQualification:
          formData.motherQualification.trim(),

        rte:
          formData.rte === true ||
          formData.rte === "true",

        image: studentImageUrl || "",
        fatherImage: fatherImageUrl || "",
        motherImage: motherImageUrl || "",
      };

      await dispatch(addStudent(payload)).unwrap();

      toast.success("Student added successfully");

      navigate("/institute/students");
    } catch (err) {
      toast.error(
        err ||
        "Failed to add student"
      );
    }
  };

  return (
    <>

      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />

            <Link to="/institute/students">Students</Link>

            <FiChevronRight className="separator" />

            <span className="active">Add Student</span>
          </div>

        </div>
      </div>
      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <h5 className="form-section-title">Student Information</h5>
          <Row className="g-3">
            <Col md={3}>
              <Form.Label>Session</Form.Label>

              <Form.Control
                type="text"
                name="session"
                value={formData.session}
                readOnly
                disabled
              />
            </Col>

            {/* Standard */}
            <Col md={3}>
              <Form.Label>Standard</Form.Label>
              <Form.Select
                value={formData.standardId}
                onChange={handleStandardChange}
              >
                <option value="">Select Standard</option>
                {standards.map((std) => (
                  <option key={std._id} value={std._id}>
                    {std.name}
                  </option>
                ))}
              </Form.Select>
              {errors.standardId && (
                <small className="text-danger">
                  {errors.standardId}
                </small>
              )}
            </Col>

            {/* Section  */}
            <Col md={3}>
              <Form.Label>Section</Form.Label>
              <Form.Select
                value={formData.sectionId}
                onChange={handleSectionChange}
                disabled={!formData.standardId}
              >
                <option value="">Select Section</option>
                {sections.map((sec) => (
                  <option key={sec._id} value={sec._id}>
                    {sec.name}
                  </option>
                ))}
              </Form.Select>

              {errors.sectionId && (
                <small className="text-danger">
                  {errors.sectionId}
                </small>
              )}
            </Col>
            <Col md={3}>
              <Form.Label>Name</Form.Label>
              <Form.Control name="name" value={formData.name} onChange={handleChange} placeholder="Name" />
              {errors.name && (
                <small className="text-danger">{errors.name}</small>
              )}
            </Col>
            <Col md={3}>
              <Form.Label>Gender</Form.Label>
              <Form.Select name="gender" value={formData.gender} onChange={handleChange}>
                <option value="">Select</option>
                <option>Male</option>
                <option>Female</option>
              </Form.Select>
              {errors.gender && (
                <small className="text-danger">{errors.gender}</small>
              )}
            </Col>
            <Col md={3}>
              <Form.Label>Roll No</Form.Label>
              <Form.Control name="rollNo" value={formData.rollNo} onChange={handleChange} placeholder="Roll No" />
              {errors.rollNo && (
                <small className="text-danger">{errors.rollNo}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>DOB</Form.Label>
              <Form.Control type="date" value={formData.dob} name="dob" onChange={handleChange} />
              {errors.dob && (
                <small className="text-danger">{errors.dob}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>DOA</Form.Label>
              <Form.Control type="date" name="doa" value={formData.doa} onChange={handleChange} />
              {errors.doa && (
                <small className="text-danger">{errors.doa}</small>
              )}
            </Col>



            <Col md={3}>
              <Form.Label>Aadhaar</Form.Label>
              <Form.Control
                name="aadhaarNo"
                value={formData.aadhaarNo}
                onChange={handleChange}
                placeholder="Aadhaar Number"
                maxLength={12}
                inputMode="numeric"
              />
              {errors.aadhaarNo && (
                <small className="text-danger">{errors.aadhaarNo}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Religion</Form.Label>
              <Form.Select
                name="religion"
                value={formData.religion}
                onChange={handleChange}
              >
                <option value="">Select Religion</option>
                <option value="Hindu">Hindu</option>
                <option value="Muslim">Muslim</option>
                <option value="Christian">Christian</option>
                <option value="Sikh">Sikh</option>
                <option value="Buddhist">Buddhist</option>
                <option value="Jain">Jain</option>
                <option value="Jewish">Jewish</option>
                <option value="Parsi">Parsi</option>
                <option value="Other">Other</option>

              </Form.Select>
              {errors.religion && (
                <small className="text-danger">{errors.religion}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Nationality</Form.Label>
              <Form.Control name="nationality" value={formData.nationality} onChange={handleChange} placeholder="Nationality" />
              {errors.nationality && (
                <small className="text-danger">{errors.nationality}</small>
              )}
            </Col>
          </Row>
          <h5 className="form-section-title mt-4">Address Details</h5>
          <Row className="g-3">
            <Col md={6}>
              <Form.Label>Present Address</Form.Label>
              <Form.Control name="presentAddress" as="textarea" value={formData.presentAddress} style={{ height: "100px" }} onChange={handleChange} placeholder="Present address" />
              {errors.presentAddress && (
                <small className="text-danger">{errors.presentAddress}</small>
              )}
            </Col>

            <Col md={6}>
              <Form.Label>Permanent Address</Form.Label>
              <Form.Control name="permanentAddress" as="textarea" style={{ height: "100px" }} value={formData.permanentAddress} onChange={handleChange} placeholder="Permanent address" />
              {errors.permanentAddress && (
                <small className="text-danger">
                  {errors.permanentAddress}
                </small>
              )}
            </Col>
          </Row>
          <h5 className="form-section-title mt-4">Father Details</h5>
          <Row className="g-3">
            {/* father */}
            <Col md={3}>
              <Form.Label>Father Name</Form.Label>
              <Form.Control
                name="fatherName"
                value={formData.fatherName}
                onChange={handleChange}
                placeholder="Father Name"
              />
              {errors.fatherName && (
                <small className="text-danger">{errors.fatherName}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Father Mobile</Form.Label>
              <Form.Control
                name="fatherMobileNo"
                value={formData.fatherMobileNo}
                onChange={handleChange}
                placeholder="Father Mobile Number"
                maxLength={10}
                inputMode="numeric"
              />
              {errors.fatherMobileNo && (
                <small className="text-danger">{errors.fatherMobileNo}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Father Email</Form.Label>
              <Form.Control name="fatherEmail" value={formData.fatherEmail} onChange={handleChange} placeholder="Father Email" />
              {errors.fatherEmail && (
                <small className="text-danger">{errors.fatherEmail}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Father Occupation</Form.Label>
              <Form.Control name="fatherOccupation" value={formData.fatherOccupation} onChange={handleChange} placeholder="Father Occupation" />
              {errors.fatherOccupation && (
                <small className="text-danger">
                  {errors.fatherOccupation}
                </small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Father Aadhaar</Form.Label>
              <Form.Control
                name="fatheraadhaar"
                value={formData.fatheraadhaar}
                onChange={handleChange}
                placeholder="Father Aadhaar"
                maxLength={12}
                inputMode="numeric"
              />
              {errors.fatheraadhaar && (
                <small className="text-danger">{errors.fatheraadhaar}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Father Qualification</Form.Label>
              <Form.Control name="fatherQualification" value={formData.fatherQualification} onChange={handleChange} placeholder="Father Qualification" />
              {errors.fatherQualification && (
                <small className="text-danger">
                  {errors.fatherQualification}
                </small>
              )}
            </Col>

          </Row>
          <h5 className="form-section-title mt-4">Mother Details</h5>
          <Row className="g-3">

            <Col md={3}>
              <Form.Label>Mother Name</Form.Label>
              <Form.Control
                name="motherName"
                value={formData.motherName}
                onChange={handleChange}
                placeholder="Mother Name"
              />

              {errors.motherName && (
                <small className="text-danger">
                  {errors.motherName}
                </small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Mother Mobile</Form.Label>
              <Form.Control
                name="motherMobileNo"
                value={formData.motherMobileNo}
                onChange={handleChange}
                placeholder="Mother Mobile Number"
                maxLength={10}
                inputMode="numeric"
              />
              {errors.motherMobileNo && (
                <small className="text-danger">{errors.motherMobileNo}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Mother Email</Form.Label>
              <Form.Control name="motherEmail" value={formData.motherEmail} onChange={handleChange} placeholder="Mother Email" />
              {errors.motherEmail && (
                <small className="text-danger">{errors.motherEmail}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Mother Occupation</Form.Label>
              <Form.Control name="motherOccupation" value={formData.motherOccupation} onChange={handleChange} placeholder="Mother Occupation" />
              {errors.motherOccupation && (
                <small className="text-danger">
                  {errors.motherOccupation}
                </small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Mother Aadhaar</Form.Label>
              <Form.Control
                name="motheraadhaar"
                value={formData.motheraadhaar}
                onChange={handleChange}
                placeholder="Mother Aadhaar"
                maxLength={12}
                inputMode="numeric"
              />
              {errors.motheraadhaar && (
                <small className="text-danger">{errors.motheraadhaar}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Mother Qualification</Form.Label>
              <Form.Control name="motherQualification" value={formData.motherOccupation} onChange={handleChange} placeholder="Mother Qualification" />
              {errors.motherQualification && (
                <small className="text-danger">
                  {errors.motherQualification}
                </small>
              )}
            </Col>
          </Row>

          <h5 className="form-section-title mt-4">
            Photographs
          </h5>

          <Row className="g-3">

            {/* STUDENT IMAGE */}

            <Col md={4}>
              <Form.Label>Student Image</Form.Label>

              <Form.Control
                name="image"
                type="file"
                accept="image/jpeg,image/png"
                onChange={handleFileChange}
              />

              {imagePreviews.image ? (
                <div className="image-upload-preview">
                  <img
                    src={imagePreviews.image}
                    alt="Student Preview"
                  />

                  <button
                    type="button"
                    className="image-remove-btn"
                    onClick={() => {
                      if (imagePreviews.image.startsWith("blob:")) {
                        URL.revokeObjectURL(imagePreviews.image);
                      }

                      setFormData((prev) => ({
                        ...prev,
                        image: "",
                      }));

                      setImagePreviews((prev) => ({
                        ...prev,
                        image: "",
                      }));
                    }}
                  >
                    ×
                  </button>
                </div>
              ) : (
                <div className="image-upload-placeholder">
                  No student image selected
                </div>
              )}
            </Col>


            {/* FATHER IMAGE */}

            <Col md={4}>
              <Form.Label>Father Image</Form.Label>

              <Form.Control
                name="fatherImage"
                type="file"
                accept="image/jpeg,image/png"
                onChange={handleFileChange}
              />

              {imagePreviews.fatherImage ? (
                <div className="image-upload-preview">
                  <img
                    src={imagePreviews.fatherImage}
                    alt="Father Preview"
                  />

                  <button
                    type="button"
                    className="image-remove-btn"
                    onClick={() => {
                      if (imagePreviews.fatherImage.startsWith("blob:")) {
                        URL.revokeObjectURL(imagePreviews.fatherImage);
                      }

                      setFormData((prev) => ({
                        ...prev,
                        fatherImage: "",
                      }));

                      setImagePreviews((prev) => ({
                        ...prev,
                        fatherImage: "",
                      }));
                    }}
                  >
                    ×
                  </button>
                </div>
              ) : (
                <div className="image-upload-placeholder">
                  No father image selected
                </div>
              )}
            </Col>


            {/* MOTHER IMAGE */}

            <Col md={4}>
              <Form.Label>Mother Image</Form.Label>

              <Form.Control
                name="motherImage"
                type="file"
                accept="image/jpeg,image/png"
                onChange={handleFileChange}
              />

              {imagePreviews.motherImage ? (
                <div className="image-upload-preview">
                  <img
                    src={imagePreviews.motherImage}
                    alt="Mother Preview"
                  />

                  <button
                    type="button"
                    className="image-remove-btn"
                    onClick={() => {
                      if (imagePreviews.motherImage.startsWith("blob:")) {
                        URL.revokeObjectURL(imagePreviews.motherImage);
                      }

                      setFormData((prev) => ({
                        ...prev,
                        motherImage: "",
                      }));

                      setImagePreviews((prev) => ({
                        ...prev,
                        motherImage: "",
                      }));
                    }}
                  >
                    ×
                  </button>
                </div>
              ) : (
                <div className="image-upload-placeholder">
                  No mother image selected
                </div>
              )}
            </Col>

          </Row>

          <div className="form-actions mt-5 mb-3">
            <button
              type="button"
              className="btn-cancel"
              style={{ color: "black" }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button type="submit" className="btn-submit">
              Submit
            </button>
          </div>
        </Form>
      </div >
    </>
  );
}
